(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-bf-campaign"] && !Shopify.designMode) return;
  try {
    
  (function(){
    if (window.__mfBfInit) return;
    window.__mfBfInit = true;

    function reducedMotion(){
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function confetti(canvas){
      if (!canvas || reducedMotion()) return;
      var ctx = canvas.getContext('2d');
      function size(){ canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
      size();
      var colors = ['#ffbf38', '#e8631a', '#1b3a2f', '#f4f2ec'];
      var pieces = [];
      for (var i = 0; i < 140; i++) {
        pieces.push({
          x: Math.random() * canvas.width,
          y: -20 - Math.random() * canvas.height * 0.5,
          w: 6 + Math.random() * 6,
          h: 8 + Math.random() * 8,
          speed: 2 + Math.random() * 3,
          drift: (Math.random() - 0.5) * 2,
          rot: Math.random() * Math.PI,
          rotSpeed: (Math.random() - 0.5) * 0.2,
          color: colors[i % colors.length]
        });
      }
      var start = performance.now();
      var duration = 5000;
      var raf;
      function frame(now){
        var elapsed = now - start;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        pieces.forEach(function(p){
          p.y += p.speed;
          p.x += p.drift;
          p.rot += p.rotSpeed;
          if (p.y > canvas.height + 20) p.y = -20;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        });
        if (elapsed < duration) {
          raf = requestAnimationFrame(frame);
        } else {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
      raf = requestAnimationFrame(frame);
      window.addEventListener('resize', size, { passive: true });
    }

    function initPopup(root){
      var overlay = root.querySelector('[data-mf-bf-overlay]');
      if (!overlay) return;
      var key = root.dataset.popupKey;
      var closeBtn = overlay.querySelector('[data-mf-bf-close]');
      var cta = overlay.querySelector('[data-mf-bf-cta]');
      var canvas = overlay.querySelector('[data-mf-bf-confetti]');

      function close(){
        overlay.hidden = true;
        document.body.classList.remove('mf-bf-lock-scroll');
        try { window.localStorage.setItem(key, '1'); } catch (e) {}
      }

      function open(){
        overlay.hidden = false;
        document.body.classList.add('mf-bf-lock-scroll');
        confetti(canvas);
      }

      var alreadySeen = false;
      try { alreadySeen = window.localStorage.getItem(key) === '1'; } catch (e) {}
      if (!alreadySeen) {
        window.setTimeout(open, 400);
      }

      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
      cta.addEventListener('click', function () {
        close();
        var target = document.querySelector('.mf-mag-offers, .mf-dren-offers');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function initMediaBadge(root){
      var text = root.dataset.mediaBadge;
      if (!text) return;
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return;
      var cs = window.getComputedStyle(gallery);
      if (cs.position === 'static') gallery.style.position = 'relative';
      var badge = document.createElement('div');
      badge.className = 'mf-bf-media-badge';
      badge.textContent = text;
      gallery.appendChild(badge);
    }

    function initCountdown(root){
      var el = root.querySelector('[data-mf-bf-countdown]');
      if (!el) return;
      var end = Date.parse(el.dataset.end);
      if (isNaN(end)) return;
      var valueEl = el.querySelector('[data-mf-bf-countdown-value]');
      function tick(){
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var sVal = Math.floor((diff % 60000) / 1000);
        valueEl.textContent = d + 'd ' + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(sVal).padStart(2, '0') + 's';
        el.hidden = false;
      }
      tick();
      var timer = setInterval(tick, 1000);
    }

    function escapeFixedElements(root){
      // En escritorio, el contenedor principal de la página (.page-wrapper) tiene su
      // propio scroll interno (overflow-y:auto). Eso recorta cualquier elemento
      // position:fixed que quede dentro a los límites de ese contenedor (se nota al
      // abrir el carrito, que lo estrecha). Los sacamos a <body> directamente para
      // que se comporten como fijos de verdad, en toda la ventana.
      var marquee = root.querySelector('.mf-bf-marquee');
      if (marquee) document.body.appendChild(marquee);
      var overlay = root.querySelector('[data-mf-bf-overlay]');
      if (overlay) document.body.appendChild(overlay);
    }

    document.querySelectorAll('[data-mf-bf-root]').forEach(function (root) {
      initPopup(root);
      initCountdown(root);
      initMediaBadge(root);
      escapeFixedElements(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
